/**
 * Client-side token estimate matching hangout worker estimateTokens (chars / 3).
 * @param {unknown} text
 * @returns {number}
 */
export const estimateTokens = (text) => Math.ceil(String(text || '').length / 3);

/**
 * @param {number} count
 * @returns {string}
 */
export const formatTokenCount = (count) => {
  const n = Number.isFinite(count) ? Math.max(0, Math.round(count)) : 0;
  return `~${n} tokens`;
};
